import { Box, Typography } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { WizardFormData } from './schemas';
import OfferDetailsSection from './components/OfferDetailsSection';
import TrafficSourceSection from './components/TrafficSourceSection';
import CampaignSection from './components/CampaignSection';
import { useWizardData } from './hooks/useWizardData';

function OverviewStep() {
  const { watch } = useFormContext<WizardFormData>();
  const { domains, trafficSources, campaigns, entryDomains, offerGroups } = useWizardData();
  const formData = watch();

  const getDomainName = (domainId: string, domains: any[]) => {
    return domains.find((d) => d._id === domainId)?.domainName || 'Unknown';
  };

  const getTrafficSourceName = (sourceId: string) => {
    return trafficSources.find((s) => s._id === sourceId)?.name || 'Unknown';
  };

  const getCampaignName = (campaignId: string) => {
    return campaigns.find((c) => c._id === campaignId)?.name || 'Unknown';
  };

  const getOfferGroupName = (groupId: string) => {
    return offerGroups.find((g) => g._id === groupId)?.label || 'Unknown';
  };

  const getFileName = (fileData: any): string => {
    if (!fileData) {
      return 'Unknown file';
    }

    const isFileObject = fileData instanceof File;
    if (isFileObject) {
      return fileData.name;
    }

    const hasNameProperty =
      'name' in fileData && typeof fileData.name === 'string';
    if (hasNameProperty) {
      return fileData.name;
    }

    return 'Unknown file';
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Overview
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Review your configuration before completing the wizard.
      </Typography>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        <OfferDetailsSection
          formData={formData}
          domains={domains}
          getDomainName={getDomainName}
        />
        <TrafficSourceSection
          getTrafficSourceName={getTrafficSourceName}
          getFileName={getFileName}
        />
        <CampaignSection
          entryDomains={entryDomains}
          getDomainName={getDomainName}
          getOfferGroupName={getOfferGroupName}
          getCampaignName={getCampaignName}
          getFileName={getFileName}
        />
      </Box>
    </Box>
  );
}

export default OverviewStep;
